import { Capacitor } from '@capacitor/core';

export const checkIsMobileVersionCompatible = (appVersion: string, minimumRequiredVersion: string): boolean => {
  const appVersionParts = appVersion.split('.').map(Number);
  const minimumVersionParts = minimumRequiredVersion.split('.').map(Number);

  for (let i = 0; i < Math.max(appVersionParts.length, minimumVersionParts.length); i++) {
    const appVersionPart = appVersionParts[i] || 0;
    const minimumVersionPart = minimumVersionParts[i] || 0;
    if (appVersionPart > minimumVersionPart) return true;
    if (appVersionPart < minimumVersionPart) return false;
  }

  return true;
};

export const checkIsThereANewerMobileVersionAvailable = (
  appVersion: string,
  latestStoreVersion: { ios: string; android: string }
): boolean => {
  if (!Capacitor.isNativePlatform()) return false;

  const appVersionParts = appVersion.split('.').map(Number);
  const currentPlatform = Capacitor.getPlatform();

  let latestStoreVersionString: string = latestStoreVersion[currentPlatform as 'ios' | 'android'];
  const latestVersionParts = latestStoreVersionString.split('.').map(Number);

  for (let i = 0; i < Math.max(appVersionParts.length, latestVersionParts.length); i++) {
    const appVersionPart = appVersionParts[i] || 0;
    const latestVersionPart = latestVersionParts[i] || 0;
    if (appVersionPart < latestVersionPart) return true;
    if (appVersionPart > latestVersionPart) return false;
  }

  return false;
};
